import { render } from "./GroupClassReportDetail.vue?vue&type=template&id=c80a8fd4&scoped=true"
import script from "./GroupClassReportDetail.vue?vue&type=script&lang=js"
export * from "./GroupClassReportDetail.vue?vue&type=script&lang=js"

import "./GroupClassReportDetail.vue?vue&type=style&index=0&id=c80a8fd4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80a8fd4"]])

export default __exports__